import { createCommentsApi } from "./CommentsAPI";

export const articleCommentsApi = createCommentsApi("article");
export const {
    getComments: GetArticleComments,
    getReplies: GetArticleCommentReplies,
    createComment: CreateArticleComment,
    editComment: EditArticleComment,
    deleteComment: DeleteArticleComment,
    setVote: SetArticleCommentVote,
    removeVote: RemoveArticleCommentVote,
    reportComment: SubmitArticleCommentReport,
    getModerationReports: GetArticleCommentModerationReports,
    resolveReport: ResolveArticleCommentReport,
    pinComment: PinArticleComment,
    unpinComment: UnpinArticleComment,
} = articleCommentsApi;
